import $ from "jquery";

export class OpenIdDiscovery {
  static #localStorageId = "openid_discovery";
  #userHub = false;
  #tokenEndpoint;
  #authorizationEndpoint;
  #logoutEndpoint;
  #issuer;

  get authorizationEndpoint() {
    return this.#authorizationEndpoint;
  }

  get tokenEndpoint() {
    return this.#tokenEndpoint;
  }

  get logoutEndpoint() {
    return this.#logoutEndpoint;
  }

  get userHub() {
    return this.#userHub;
  }

  constructor(issuer, userHub) {
    this.#userHub = userHub;
    this.#issuer = issuer;
  }

  doDiscovery() {
    const self = this;

    function completeDiscovery(discovery, resolve) {
      console.log("discovery is: %o", discovery);
      self.#tokenEndpoint = discovery.token_endpoint;
      self.#authorizationEndpoint = discovery.authorization_endpoint;
      self.#logoutEndpoint = discovery.end_session_endpoint;
      resolve(self);
    }

    return new Promise((resolve, reject) => {
      let discovery = localStorage.getItem(OpenIdDiscovery.#localStorageId);
      if (typeof discovery !== "undefined") {
        discovery = JSON.parse(discovery);
      }

      if (
        discovery === undefined ||
        discovery === null ||
        discovery.validUntil >= Date.now() ||
        discovery.issuer !== this.#issuer
      ) {
        $.ajax({
          cache: false,
          url: this.#issuer + "/.well-known/openid-configuration",
          timeout: 10000,
          accept: "application/json",
          success: (data) => {
            discovery = data;
            discovery.validUntil = Date.now() + 12 * 60 * 60 * 1000; // 12 hours in millis
            discovery.issuer = self.#issuer;
            localStorage.setItem(OpenIdDiscovery.#localStorageId, JSON.stringify(discovery));
            completeDiscovery(discovery, resolve);
          },
          error: (xhr, textStatus, errorThrown) => {
            console.log(`Failed to discovery config ${textStatus} ${errorThrown}`);
            if (typeof discovery !== "undefined") {
              reject(xhr, textStatus, errorThrown);
            }
          },
        });
      } else {
        completeDiscovery(discovery, resolve);
      }
    });
  }
}
